import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { highlight } from '@helpers/utils/highlight/highlight';
import { EllipsisDetector } from '@terminal/components/ellipsis-detector/EllipsisDetector';
import { useTheme } from '@terminal/react-query-hooks/themes/useThemeOverview';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import styles from './ThemeCell.module.scss';

const DEFAULT_SIZE = 32;

export interface ThemeCellProps {
  themeId: string;
  size?: number;
  highlightedText?: string;
}

export const ThemeCell = ({
  themeId,
  size = DEFAULT_SIZE,
  highlightedText,
}: ThemeCellProps) => {
  const { data: theme, isLoading, isError } = useTheme({ themeId });

  if (isLoading) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: `${size}px`,
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  if (isError || !theme) {
    return null;
  }

  return (
    <div className={styles.root} data-testid="theme-cell">
      <ThemeLogoIcon
        logo_url={theme.logo_url}
        name={theme.name}
        type={theme.type}
        size={size}
      />
      <div className={styles.flexColumn}>
        <EllipsisDetector inPortal label={theme.name}>
          <div className={styles.nameLabel}>
            {highlightedText
              ? highlight(theme.name, highlightedText)
              : theme.name}
          </div>
        </EllipsisDetector>
      </div>
    </div>
  );
};
